/**
*****************************************
*										                    *
* NAGARRO  - CSX - CONFIDENTIAL         *
*										                    *
*****************************************
*/
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { debounceTime } from 'rxjs/operators';

import { CommonHistory } from '../../../core/model/common-history.model';
import { HistoryOps } from '../../../core/model/history-ops.model';
import { LmsRendererService } from '../../../core/services/lms-renderer.service';

@Component({
  selector: 'lms-train-history-details',
  templateUrl: './train-history-details.component.html',
  styleUrls: ['./train-history-details.component.scss']
})
export class TrainHistoryDetailsComponent implements OnInit, OnChanges {

  @Input() history: Array<CommonHistory>;
  @Input() historyOps: HistoryOps;

  heightToApplied: number;
  upperHeight: number;

  /**
   * Creates an instance of TrainHistoryDetailsComponent.
   * @memberOf TrainHistoryDetailsComponent
   */
  constructor(private lmsRendererService: LmsRendererService) {
    this.lmsRendererService.resizeObervable.pipe(debounceTime(10)).subscribe((isResize) => {
      if (isResize) {
        this.prepareHeightForPage();
      }
    });
  }

  ngOnChanges() {
    if (this.history && this.history.length > 0) {
      this.prepareHeightForPage();
    }
  }

  /**
   * this is the life cycle method od this component
   * and called on initialization of this component
   * @memberOf TrainHistoryDetailsComponent
   */
  ngOnInit() {
    this.prepareHeightForPage();
  }

  /**
   * this method is used to calculate
   * height for the history table
   * @private
   * @memberof TrainHistoryDetailsComponent
   */
  private prepareHeightForPage() {
    if (this.lmsRendererService.getWindowWidth() >= 1280) {
      this.upperHeight = 204; // this 204 is the height in pixel of upper part of table
      // that includes height of application header, tab area and top sticky header etc.
    } else {
      this.upperHeight = 225; // this 225 is the height in pixel of upper part of table when browser has width less then 1280
      // in this case we subtract extra 21 px(height of bottom horizontal scroll) to avoid page level scroll
    }
    this.heightToApplied = this.lmsRendererService.getWindowHeight() - this.upperHeight;
  }

}
